import { LessonTypeType } from '@openeducation/oe-it-shared-types';

import LessonsDao from '../dao/lessons.dao';
import type { Environment } from '../interfaces/environment';

export abstract class LessonsService {
  static async getStudentLessonsByUnit(
    env: Environment,
    contactId: string,
    unitId?: number,
    lessonType?: LessonTypeType
  ) {
    if (!env || !contactId || !unitId || !lessonType) {
      return Promise.reject(new Error('Invalid id'));
    }

    const lessons = await LessonsDao.getStudentLessonsByUnit(
      env,
      contactId,
      unitId,
      lessonType
    );
    return lessons.filter((lesson) => lesson.type === 'Lesson');
  }
}
